import getFilterWithCol from '../../helpers/getFilterWithCol';

import { filterStore } from '../../components/common';
import { filterSort } from '../categories/filters';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search collection name',
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const filterScopeToSellerStore = ['FilterHidden', {
  id: 'scopeToSellerStore',
  build: builder => builder.add('custom', { scopeToSellerStore: true }),
}];

export const ADMIN = [
  ...[
    [filterSearch, 8],
    [filterStore, 8],
    [filterSort, 8],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
];

export const SELLER = [
  ...[
    [filterSearch, 12],
    [filterSort, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
  filterScopeToSellerStore,
];
